import "./Settings.css";
import React, { useEffect, useState } from "react";
import { ListItemText, Alert, MenuList, MenuItem } from "@mui/material";
import AddSubCategory from "../../controllers/properties/addSubCategory";
import getPropertyCategories from "../../controllers/properties/getPropertyCategories";
// import PropertyCategories from "./PropertyCategories/PropertyCategories";
import BasicSettings from "./BasicSettings/BasicSettigns";
import { getCurrencyList } from "currency-map-country";
import getCustomUnits from "../../controllers/properties/getCustomUnits";
import AddCustomUnit from "../../controllers/properties/addCustomUnit";
import setSettings from "../../controllers/settings/setSettings";
import getSettings from "../../controllers/settings/getSettings";

const CurrencyList = getCurrencyList();

const Settings = () => {
  const [targetCategory, setTargetCategory] = React.useState("");
  const [modalVisibility, setModalVisibility] = React.useState(false);
  const [ErrVisibility, setErrVisibility] = React.useState(false);
  const [addRequestInProgress, setAddRequestInProgress] = React.useState(false);
  const [home, setHome] = React.useState([]);
  const [plot, setPlot] = React.useState([]);
  const [commercial, setCommercial] = React.useState([]);

  const showError = () => {
    setErrVisibility(true);
    setTimeout(() => {
      setErrVisibility(false);
    }, 3000);
  };
  const addSubCategory = (newSubCategory) => {
    setAddRequestInProgress(true);
    if (
      (targetCategory === "home" &&
        home.filter((a) => a === newSubCategory).length !== 0) ||
      (targetCategory === "plot" &&
        plot.filter((a) => a === newSubCategory).length !== 0) ||
      (targetCategory === "commercial" &&
        commercial.filter((a) => a === newSubCategory).length !== 0)
    ) {
      /** If new category exists previously, it can't be added */
      showError();
      setAddRequestInProgress(false);
    } else
      AddSubCategory(targetCategory, [
        ...(targetCategory === "home"
          ? home
          : targetCategory === "plot"
          ? plot
          : commercial),
        newSubCategory,
      ])
        .then(() => {
          targetCategory === "home"
            ? setHome([...home, newSubCategory])
            : targetCategory === "plot"
            ? setPlot([...plot, newSubCategory])
            : setCommercial([...commercial, newSubCategory]);

          setModalVisibility(false);
          setAddRequestInProgress(false);
        })
        .catch(() => {
          setAddRequestInProgress(false);
        });
  };
  const removeSubCategory = async (category) => {
    let newArr = [];
    if (targetCategory === "home") {
      newArr = [...home.filter((a) => a !== category)];
      //   setHome([...newArr]);
    } else if (targetCategory === "plot") {
      newArr = [...plot.filter((a) => a !== category)];
      //   setPlot([...newArr]);
    } else if (targetCategory === "commercial") {
      newArr = [...commercial.filter((a) => a !== category)];
      //   setCommercial([...newArr]);
    }

    await AddSubCategory(targetCategory, [...newArr]).then(() => {
      if (targetCategory === "home") {
        setHome([...newArr]);
      } else if (targetCategory === "plot") {
        setPlot([...newArr]);
      } else if (targetCategory === "commercial") {
        setCommercial([...newArr]);
      }
    });
  };
  const getAllCustomCategories = async () => {
    const categories = await getPropertyCategories();
    setHome(categories.home || []);
    setPlot(categories.plot || []);
    setCommercial(categories.commercial || []);
  };

  useEffect(() => getAllCustomCategories(), []);

  const [value, setValue] = React.useState("Home");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [ActiveSetting, setActiveSetting] = useState(0);
  const switchActiveSetting = (index) => {
    setActiveSetting(index);
  };

  /****************
   * Basic Settings
   ****************/
  /* land units */
  const [addUnitInProgress, setAddUnitInProgress] = useState(false);
  const [landUnits, setLandUnits] = useState([]);
  const getLandUnits = async () => setLandUnits([...(await getCustomUnits())]);
  const [BasicErrVisibility, setBasicErrVisibility] = React.useState(false);
  const showBasicError = () => {
    setBasicErrVisibility(true);
    setTimeout(() => {
      setBasicErrVisibility(false);
    }, 3000);
  };
  const addNewUnit = async (newUnit) => {
    if (landUnits.includes(newUnit)) {
      showBasicError();
    } else {
      setAddUnitInProgress(true);
      const newUnitsArr = [...landUnits, newUnit];
      await AddCustomUnit(newUnitsArr);
      setLandUnits([...newUnitsArr]);
      setAddUnitInProgress(false);
      setModalVisibility(false);
      return true;
    }
  };
  const removeUnit = async (unit) => {
    setAddUnitInProgress(true);
    const units = landUnits.filter((e) => e !== unit);
    const newUnitsArr = [...units];
    await AddCustomUnit(newUnitsArr);
    setLandUnits([...newUnitsArr]);
    setAddUnitInProgress(false);
    return true;
  };
  useEffect(() => getLandUnits(), []);
  /* Settings */
  const [settings, set_settings] = useState(null);
  const updateCountry = async (value) => {
    if (value === "") return;
    const newSettings = { ...settings, country: value };
    await setSettings(newSettings);
    set_settings(newSettings);
  };
  const updateCurrency = async (value) => {
    if (value === "") return;
    const newSettings = { ...settings, currency: value };
    set_settings(newSettings);
    await setSettings(newSettings);
  };
  const updateCurrencyFormat = async (value) => {
    if (value === "") return;
    const newSettings = { ...settings, currencyFormat: value };

    await setSettings(newSettings);
    set_settings(newSettings);
  };
  const updateUnit = async (value) => {
    if (value === "") return;
    const newSettings = { ...settings, unit: value };
    await setSettings(newSettings);
    set_settings(newSettings);
  };

  useEffect(() => {
    async function fetchData() {
      // You can await here
      const result = (await getSettings()) || {};
      if (!result.country) updateCountry("Pakistan");
      set_settings(result);
      // ...
    }
    fetchData();
  }, []);

  return (
    <div className="global-body-container">
      {/* <div id="content-body-height" className="content-body"> */}

      <div className="d-flex align-items-start" id="flex-none">
        <div className="mr-auto d-lg-block mb-50">
          <h2 className="text-black mb-0 pr-3 custom-heading">Settings</h2>
        </div>

        <div className="dropdown custom-dropdown mr-3 mb-50"></div>
      </div>

      <div className="custom-center-box">
        <div className="" id="deals-all">
          <div className="m-auto">
            {ActiveSetting === 0 && settings && (
              <BasicSettings
                {...{
                  CurrencyList,
                  addNewUnit,
                  landUnits,
                  addUnitInProgress,
                  removeUnit,
                  settings,
                  updateCountry,
                  updateCurrency,
                  updateCurrencyFormat,
                  BasicErrVisibility,
                  modalVisibility,
                  setModalVisibility,
                  updateUnit,
                }}
              />
            )}
            {/* {ActiveSetting === 1 && (
                    <PropertyCategories
                      {...{
                        targetCategory,
                        setTargetCategory,
                        modalVisibility,
                        setModalVisibility,
                        ErrVisibility,
                        addRequestInProgress,
                        home,
                        plot,
                        commercial,
                        addSubCategory,
                        removeSubCategory,
                        value,
                        handleChange,
                      }}
                    />
                  )} */}
          </div>
        </div>
      </div>

      {/* </div> */}

      {ErrVisibility && (
        <div
          className="position-absolute m-auto"
          style={{ width: "100%", maxWidth: 400, right: 40, zIndex: 1000000 }}
        >
          <Alert variant="outlined" severity="error" className="bg-white">
            This category already exists
          </Alert>
        </div>
      )}
    </div>
  );
};

const MenuItemJSX = ({ index, active, title, switchActiveSetting }) => {
  return (
    <MenuItem onClick={() => switchActiveSetting(index)}>
      <ListItemText className={index === active && "text-blue"}>
        {title}
      </ListItemText>
    </MenuItem>
  );
};

export default Settings;
